module.exports = __webpack_public_path__ + "img/homie_roblyaushall.e1889b6.png";